import { render } from "./Tem012.vue?vue&type=template&id=3cb4f459"
import script from "./Tem012.vue?vue&type=script&lang=js"
export * from "./Tem012.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__